import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'salades',
  templateUrl: './salades.component.html',
  styleUrls: ['./salades.component.scss']
})
export class SaladesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/salades/salades.component.ts